import {
    useBuscarGraficoTasaChequeRechazoDashboard,
    useBuscarGraficoTasaSolicitudPagoRechazoDashboard,
    useBuscarGraficoTasaSolicitudPagoAprobadoDashboard,
    useBuscarGraficoDiferenciaCambiariaPerdidaDashboard,
    useBuscarGraficoDiferenciaCambiariaGananciaDashboard,
    useBuscarGraficoSolicitudesPagoPorEstatusDashboard
} from "../../Scripts/Services/banco-dashboard-service.js";
import { SelectButton, Messages  } from 'primereact';
import React, {useEffect, useState} from 'react';
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import {useTheme} from "../../../Commons/Scripts/Hooks";
import { renderToStaticMarkup } from "react-dom/server";
import * as XLSX from "xlsx";
export const GraficosBanco = () => {
    const {theme} = useTheme();
    const color = ["#3fb1e3", "#91cc75", "#fac858", "#ee6666","#73c0de","#3ba272", "#fc8452","#9a60b4","#ea7ccc"];
    const moneda = window.monedaPredeterminada;
    const labelOptions = {
        show: true,
        rotate: 90,
        align: 'left',
        position: 'insideBottom',
        verticalAlign: 'middle',
        color: '#000',
        fontSize: 12,
    }
    const [where, setWhere] = React.useState({where :{periodo:'mensual'}});
    const [value, setValue] = React.useState(3);
    const periodos = [
        { name: 'Diario', value: 1 },
        { name: 'Semanal', value: 2 },
        { name: 'Mensual', value: 3 },
        { name: 'Trimestral', value: 4 },
        { name: 'Anual', value: 5 }
    ];
    const {data: tasaChequesRechazo} = useBuscarGraficoTasaChequeRechazoDashboard(where);
    const {data: tasaSolicitudesPagoRechazo} = useBuscarGraficoTasaSolicitudPagoRechazoDashboard(where);
    const {data: tasaSolicitudesPagoAprobado} = useBuscarGraficoTasaSolicitudPagoAprobadoDashboard(where);
    const {data: perdidaDiferenciaCambiaria} = useBuscarGraficoDiferenciaCambiariaPerdidaDashboard(where)
    const {data: gananciaDiferenciaCambiaria} = useBuscarGraficoDiferenciaCambiariaGananciaDashboard(where)
    const {data: solicituesPagoPorEstatus} = useBuscarGraficoSolicitudesPagoPorEstatusDashboard(where)
    function m(n, d) {
        //Convertir numero => 3,000,000 a 3M
        const x = Math.floor(Math.log10(Math.abs(n)));
        const suffix = ['','k','M','MM','T','P','E'];
        const magnitude = Math.floor(x / 3);
        const scaled = n / Math.pow(10, magnitude * 3);
        const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

        return rounded + ' ' + suffix[magnitude];
    } 
    function handleChange(value) {
        setValue(value);
        switch(value){
            case 1:
                setWhere({where: {periodo:'diario'}});
                break;
            case 2:
                setWhere({where: {periodo:'semanal'}});
                break;
            case 3:
                setWhere({where: {periodo:'mensual'}});
                break;
            case 4:
                setWhere({where: {periodo:'trimestral'}});
                break;
            case 5:
                setWhere({where: {periodo:'anual'}})
                break;
        }
    }
    function crearDivGrafico(data){
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }   
    }
    function crearGrafico2(data){ 
            crearDivGrafico(data);
            const svgString = renderToStaticMarkup(<SvgComponent
                iconName="export"
                fill={theme.color1}
            />);
            const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
            var chartDom = document.getElementById('chart_' + data.Titulo);
            const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
            var options = {
                color: color,
                toolbox: {
                    show: true,
                    feature: {
                        myTool1: {
                            show: true,
                            title: 'exportar',
                            icon: `image://${svgDataUrl}`,
                            onclick: function (){
                                const option = chart.getOption();
                                const source = option.dataset[0].source;
                                const dimensions = option.dataset[0].dimensions;

                                const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                                const ws = XLSX.utils.aoa_to_sheet(rows);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                                XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                            }
                        }
                    }
                },
                title: {
                    text: data.Titulo,
                    left: 'center',
                    textStyle: {
                        fontStyle: 'normal',
                        fontWeight: 'bolder',
                        fontFamily: 'sans-serif'
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: 'bottom',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                },
                dataset: {
                    dimensions: ['periodo','Aprobada', 'Rechazada', 'Validada', 'Nuevo', 'Pagada'],
                    source: data.Resultados.map((d) => {
                        var col = { periodo: d.FechaDesc };
                        return {
                            ...col,
                            ...Object.fromEntries(d.Tops.map((e) => [e.Desc, e.Monto])),
                        };
                    }),
                },
                xAxis: { type: 'category', },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        fontSize: 9,
                        formatter: function (params) {
                            if(data.Titulo?.includes("Tasa")){
                                return `${params} %`
                            }else {
                                if(params >= 1000) return `${moneda} ${m(params,1)}`
                                else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`  
                            }                     
                        }
                    },
                },
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series:
                    [
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Total",
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                            }
                        },
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Total",
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                            }
                        },
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Total",
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                            }
                        },
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Total",
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                            }
                        },
                        {
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            stack: "Total",
                            tooltip: {
                                valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                            }
                        },
                    ]
            };
            let dataset = options.dataset.source;
            let keysToAdd = ['Aprobada', 'Rechazada', 'Validada', 'Nuevo', 'Pagada'];
            for (let i = 0; i < dataset.length; i++) {
                for (let j = 0; j < keysToAdd.length; j++) {
                    if (!dataset[i].hasOwnProperty(keysToAdd[j])) {
                        dataset[i][keysToAdd[j]] = 0;
                    }
                }
            }          
            options.dataset.source = dataset
            chart.setOption(options);
    }
    function crearGrafico(data){ 
    crearDivGrafico(data);
    const svgString = renderToStaticMarkup(<SvgComponent
        iconName="export"
        fill={theme.color1}
    />);
    const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
    var chartDom = document.getElementById('chart_' + data?.Titulo);
    const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
    var options = {
        color: color,
        title: {
            text: data.Titulo,
            left: 'center',
            textStyle: {
                fontStyle: 'normal',
                fontWeight: 'bolder',
                fontFamily: 'sans-serif'
            }
        },
        toolbox: {
            show: true,
            feature: {
                myTool1: {
                    show: true,
                    title: 'exportar',
                    icon: `image://${svgDataUrl}`,
                    onclick: function (){
                        const option = chart.getOption();
                        const source = option.dataset[0].source;
                        const dimensions = option.dataset[0].dimensions;

                        const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                        const ws = XLSX.utils.aoa_to_sheet(rows);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                        XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                    }
                }
            }
        },
        legend: {
            orient: 'horizontal',
            left: 'center',
            top: 'bottom',
            show: false
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
        },
        dataset: {
            dimensions: ['periodo', 'Total'],
            source: data.Resultados.map((d) => {
                return {
                    periodo: d.FechaDesc,
                    Total: d.Monto,
                }
            })
        },
        xAxis: { type: 'category', },
        yAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 9,
                formatter: function (params) {
                    if(data.Titulo?.includes("Tasa") || data.Titulo?.includes("Margen")){
                        return `${params} %`
                    }else {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`  
                    }                    
                }
            },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series:
            [
                {
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        ...labelOptions,
                        formatter: function (params) {
                            if(data.Titulo.includes("Tasa") || data.Titulo.includes("Margen")){
                                return params.value.Total.toFixed(2) + "%";
                            }else {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                            }
                        },
                    },
                    tooltip: {
                        valueFormatter: value => data.Titulo?.includes("Tasa") ?  value.toFixed(2) + "%" : moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value) 
                    }
                },
            ]
    };
    chart.setOption(options);
}
    React.useEffect(() => {
        if(tasaChequesRechazo){
            crearGrafico(tasaChequesRechazo);
        }
    }, [tasaChequesRechazo])
    React.useEffect(() => {
        if(tasaSolicitudesPagoRechazo){
            crearGrafico(tasaSolicitudesPagoRechazo);
        }
    }, [tasaSolicitudesPagoRechazo])
    React.useEffect(() => {
        if(tasaSolicitudesPagoAprobado){
            crearGrafico(tasaSolicitudesPagoAprobado);
        }
    }, [tasaSolicitudesPagoAprobado])
    React.useEffect(() => {
        if(perdidaDiferenciaCambiaria){
            crearGrafico(perdidaDiferenciaCambiaria);
        }
    }, [perdidaDiferenciaCambiaria])
    React.useEffect(() => {
        if(gananciaDiferenciaCambiaria){
            crearGrafico(gananciaDiferenciaCambiaria);
        }
    }, [gananciaDiferenciaCambiaria])
    React.useEffect(() => {
        if(solicituesPagoPorEstatus){
            crearGrafico2(solicituesPagoPorEstatus);
        }
    }, [solicituesPagoPorEstatus])
    return (
        <div>
            <SelectButton 
            value={value}
            onChange={(e) => handleChange(e.value)}
            optionLabel='name'
            options= {periodos}
            style={{    
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px',
                padding: '12px',
                flexFlow: 'columnWrap',
                aligItems: 'center',}}
            />  
            <div id="chart_holder" class="card_row"></div>
        </div>        
    )
} 
